import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("hm_token");
    if (!token) { setReady(true); return; }
    api.me()
      .then((u) => setUser(u))
      .catch(() => { localStorage.removeItem("hm_token"); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    try {
      const res = await api.login({ email, password });
      localStorage.setItem("hm_token", res.token);
      setUser(res.user);
      return { ok: true, user: res.user };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Помилка входу" };
    }
  };

  const register = async (name, email, password) => {
    try {
      const res = await api.register({ name, email, password });
      localStorage.setItem("hm_token", res.token);
      setUser(res.user);
      return { ok: true, user: res.user };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Помилка реєстрації" };
    }
  };

  const logout = () => {
    localStorage.removeItem("hm_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
